// extracted by mini-css-extract-plugin
export var container = "_tf-0";
export var table = "_tf-2";
export var tableWrapper = "_tf-1";